
<p class="text-center">{{message}}</p>
<div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <button mat-raised-button color="primary" style="background: #00669A; color: #fff;" class="btn-block btn-lg m-t-20 m-b-20" type="button" (click)="Confirm()" >Sí</button>
</div>
<div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" style="margin-top: 5%;">
    <button mat-raised-button color="primary" style="background: #00669A; color: #fff;" class="btn-block btn-lg m-t-20 m-b-20" type="button" (click)="closeModal()" >Cancelar</button>
</div>
